var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgHiemoj = function SvgHiemoj(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "eng80X2ktmo1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 251 201",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M169.35,150.33c1.72888-1.414451,3.88643-2.200618,6.12-2.23c1.044773.007636,2.080237.197132,3.06.56",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 50.02,
    ry: 54.63,
    transform: "translate(200.48 145.87)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "eng80X2ktmo9",
    d: "M186.84,97.82c.182015-.283237.437872-.511434.74-.66l.34-.17c-.15.06,0,0,.07,0c.23-.07.45-.15.68-.21.47-.12.94-.21,1.42-.3l.66-.11h.13.37c.452985-.025122.907015-.025122,1.36,0h.66c-.28,0,0,0,.1,0l.34.08c.638307.117922,1.207247.475746,1.59,1c.427892.668508,1.29379.9023,2,.54.706762-.428172.945831-1.340178.54-2.06-1.49-2.24-4.08-2.87-6.64-2.65s-5.56.68-7,3c-.293428.463838-.310093,1.050901-.043452,1.530638s.774009.775539,1.322851.771238s1.051511-.308018,1.310601-.791876Z",
    transform: "translate(0-5.000404)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "eng80X2ktmo10",
    d: "M215.55,101.69c.24-.07.47-.12.71-.17s-.24,0,.08,0h.36c.239766-.014989.480234-.014989.72,0c.07,0,.47.06.08,0l.36.06c.24,0,.47.11.71.18l.34.12c.05,0,.43.17.1,0c.455786.193013.891259.430848,1.3.71c0,0,.218469.151977.31.22.027454.020403.09.07.09.07.19.16.38.33.56.51s.35.37.51.56.27.36.08.1c.078959.099224.152403.202713.22.31.144988.212722.278512.433036.4.66l.15.28c0,0,.18.4.11.23s.08.2.09.25.09.24.13.37.14.55.2.83c.240955.778094,1.05244,1.227939,1.84,1.02.771471-.253564,1.210447-1.065669,1-1.85-1-5-6.27-8.84-11.3-7.4-.800813.220914-1.270914,1.049187-1.05,1.85s1.049187,1.270914,1.85,1.05Z",
    transform: "translate(-.333299 4.150146)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "eng80X2ktmo12",
    transform: "matrix(.977543-.210737 0.210737 0.977543-21.281703 41.693719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M199,120c0,8.47-8.31,21-14,15.33-9.32-9.31-14.47-6.66-14-16.51.27-5.64,3.37-10.72,8.16-12.86C189.24,101.38,199,109.43,199,120Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 9.92,
    ry: 8.39,
    transform: "matrix(.377033-.9262 0.9262 0.377033 185.158288 122.171459)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5,
    ry: 4.23,
    transform: "matrix(.377033-.9262 0.9262 0.377033 184.060157 123.296326)",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.37,
    ry: 2.01,
    transform: "matrix(.377033-.9262 0.9262 0.377033 182.249902 119.067898)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.71,
    ry: 0.77,
    transform: "matrix(.966823-.255446 0.255446 0.966823 185.325743 127.442695)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "eng80X2ktmo18",
    transform: "matrix(.917487 0.397765-.397765 0.917487 69.494284-75.843779)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.54,128.87c0,8.47,8.32,21,14,15.33c9.32-9.31,14.48-6.66,14-16.51-.27-5.64-3.38-10.72-8.17-12.86-10.12-4.53-19.83,3.52-19.83,14.04Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 8.39,
    ry: 9.92,
    transform: "matrix(.9262-.377033 0.377033 0.9262 218.343262 132.227739)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 4.23,
    ry: 5,
    transform: "matrix(.9262-.377033 0.377033 0.9262 218.415637 132.24987)",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "eng80X2ktmo22",
    rx: 2.01,
    ry: 2.37,
    transform: "matrix(.9262-.377033 0.377033 0.9262 222.373912 130.00915)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 0.77,
    ry: 0.71,
    transform: "matrix(.255446-.966823 0.966823 0.255446 217.171251 136.35761)",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.226678 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M166.29,125.8c1.53-.55,7.12,1.57,10,3.09c2.332757,1.206565,4.575265,2.580143,6.71,4.11c2.971646,2.19162,5.658968,4.744576,8,7.6",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,135.28c-1.53-.56-7.12,1.57-10,3.09-2.356172,1.191392-4.619243,2.558594-6.77,4.09-2.974413,2.184497-5.662184,4.734519-8,7.59",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.717058,149.215001c1.788884-1.333577,1.083287-1.119658,3.312942-1.035001c1.032799.059184-.087119.192703.865219.596719",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.974563,156.080529c2.137526.809593,2.370464-.790269,3.595437,1.139471.594166.94759-.237491-.313563.05.767322",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "eng80X2ktmo29",
    transform: "translate(.000001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219.24,166.36C216.8,177,201.85,187.5,187.78,182.5s-21.86-21.28-16.55-30.5c5.05-8.8,7.39,2.5,22,6.64c16.63,4.71,31.08-14.28,26.01,7.72Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.18,162c-.81,4.32-9.36,10.18-17.8,7.18s-13.65-10.2-11.25-13.9c2.79-4.31,5.74,2.09,14.25,3.93c7.51,1.67,16.54-6.52,14.8,2.79Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.75,172.41c5.5-.56-.31,9.39-5,8.6-2.09-.36-7.81.15-7.5-5.59.29-5.32,2.15-5.81,4.6-3.35c3.51,3.59-.59,1.21,7.9.34Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.85,174c0,0-.32,0-.25,1.88.1,2.24.19,1.31,0,1.08",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("g", {
    id: "eng80X2ktmo34",
    transform: "matrix(.927208 0.374547-.374547 0.927208 41.720934-22.573202)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M118.63,187.75v0c-1.230718.403179-2.573373.279506-3.709735-.341705s-1.965271-1.68466-2.290265-2.938295l-21-68.21c-.875405-2.645776.430999-5.519863,3-6.6v0c1.230718-.403179,2.573373-.279506,3.709735.341705s1.965271,1.68466,2.290265,2.938295l21,68.22c.879703,2.643324-.428793,5.517652-3,6.59Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.55,91.76L35.28,134.11c-5.26,1.93-11-1.16-12.73-6.9L1,57.32c-1.77-5.74,1.06-12,6.31-13.89L122.62,1.08c5.26-1.94,10.95,1.15,12.72,6.9l21.53,69.88c1.77,5.74-1.06,11.97-6.32,13.9Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("text", {
    id: "eng80X2ktmo38",
    dx: 0,
    dy: 0,
    fontFamily: "\"Rockwell\"",
    fontSize: 65.48,
    fontWeight: 400,
    transform: "matrix(1.15-.44 0.3 0.95 36.39 103.019998)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("tspan", {
    fontFamily: "\"Rockwell\"",
    fontSize: 65.48,
    fontWeight: 400,
    fontStyle: "normal",
    transform: "matrix(1.15-.44 0.3 0.95 36.39 103.02)"
  }, "\nHI!\n"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.5,151.74c0,2.25-3.34,1.66-6.17,2.14-3.65.62-4.88-1.13-4.75-3c.088484-2.582479,2.167171-4.652414,4.75-4.73c2.88,0,6.17,3.33,6.17,5.59Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.92,157.11c0,2.25-.46,4.61-3.32,4.94-4.73.53-11.92-5.17-9-6.88c4.14-2.44,2-1.2,7.12-2.14c1.241485-.215317,2.516055.105768,3.50736.883561s1.606408,1.939374,1.69264,3.196439Z",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,168.17c.21-2.84,0-5.15-.51-6.13-1.8-3.28-6-4-14.29-5.58-1.343454-.300016-2.736546-.300016-4.08,0-2.021526.533024-3.814985,1.708775-5.11,3.35-.650809.841894-1.166957,1.779731-1.53,2.78",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.51,175.42c.273632-1.210192.794536-2.350734,1.53-3.35c1-1.36,2.42-2.36,5.61-3.34c5.12-1.58,8.69-2.69,11.74-.56.32.22,3,2.18,3.06,5c0,2.3-1.78,4-3.57,5.57-6.08,5.27-12,10.41-22.46,12.26-2.8.5-4.22.83-5.69.4-6-1.75-9.33-10.91-12.68-21.58-4.71-15,4.6-31.25,18.88-28.43c5.41,1.07,13.21,2.88,16.68,9.2.62,1.13,2.06,2.76,1.7,4.74-.186204,1.194663-.928402,2.230029-2,2.79-1.46.6-2.38-.65-5.11-1.68-3.068782-1.261323-6.511218-1.261323-9.58,0-.588867.300768-1.142298.666368-1.65,1.09-.851362.778725-1.532314,1.725249-2,2.78",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.74,177.09c-3.366947-.168952-6.459623,1.849767-7.66,5-.44058,1.454025-.44058,3.005975,0,4.46",
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10
  }))))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgHiemoj);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hiemoj.54d806c13c9bda829daf1d72f0af6014.svg";